import { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import './com-pagination.less'

/*
 * props参数
 * className: 自定义class
 * currentPage: 默认当前页码
 * pageSize: 每页展示条数
 * total: 总条数
 * pagerCount: 页码按钮的数量，当总页数超过该值时会折叠  大于等于 5 且小于等于 21 的奇数
 * layout: 是否展示 total总条数
 * change: 翻页器变化触发的父级方法
 */ 

const ComPagination = ({ pageSize=10, pagerCount=5, ...props }) => {
  const [state, setState] = useState({
    current: 1,    //当前页数
    totalPage: 1,   //总共有多少页
    indexs: []     //分页器数组
  })
  useEffect(() => {
    getTotalPage();
  }, [props.total, props.currentPage])

  const getTotalPage = () => {   //获取总页数
    let current = +props.currentPage || 1;
    let totalPage = !props.total ? 1 : Math.ceil(props.total/pageSize);
    let indexs = assemblePageList(current, totalPage);
    setState(pre => ({...pre, current, totalPage, indexs }));
  }
  const isEps = (item) => {   //判断是否为省略号
    return (item+'').includes('ellipsis');
  }
  const pushNum = (val, len) => {   //向数组中插入数
    let _arr = [];
    for (let i=val; i<=len; i++){
      _arr.push(i);
    }
    return _arr;
  }
  const assemblePageList = (current, totalPage) => {  //组装分页器 current左右边数组长度逻辑: 差值大于pagerCount一半的加省略号，反之则有多少展示多少  如: (1 ... 3 4 cur=5 6 7 ... 9)
    let _half = parseInt(pagerCount/2), _isNeed = totalPage > pagerCount;
    let _ltEps = _isNeed && (current-1>_half), _rtEps = _isNeed && (totalPage-current>_half);  //左、右是否需要省略号
    let _ltLen = _ltEps ? (_half+1) : (current-1), _rtLen = pagerCount - _ltLen;

    if (_ltEps && _rtEps) _rtLen = _half+1;  //左边、右边都需要省略号
    if (!_rtEps){   //右边不需要省略号，需要全部展示
      _rtLen = totalPage - current;
      _ltLen =  (_isNeed ? pagerCount : (totalPage-1)) - _rtLen;
    }

    // 获取左数组
    let _left = [], _right = [];
    if (!_ltEps){
      _left = pushNum(1, _ltLen);
    }else {
      _left = [1, 'lt-ellipsis', ...pushNum(current-(_ltLen-2), current-1)];
    }
    // 获取右数组
    if (!_rtEps){
      _right = pushNum(current+1, totalPage);
    }else {
      _right = [...pushNum(current+1, current+(_rtLen-2)), 'rt-ellipsis', totalPage];
    }
    return [..._left, current, ..._right];
  }
  const pageChange = (e) => {   //点击了翻页  如果点击了省略号就向前或者向后跳pagerCount-2（除去首尾）
    let _page = e.target.dataset.item, { current, totalPage } = state;
    if (_page == current) return;

    if ((_page+'').includes('ellipsis')){
      let _dis = pagerCount-2, _ltDis = current - _dis, _rtDis = current + _dis;
      if (_page=='lt-ellipsis') _page = _ltDis > 0 ? _ltDis : 1;
      if (_page=='rt-ellipsis') _page = _rtDis < totalPage ? _rtDis : totalPage;
    }
    current = +_page;
    let indexs = assemblePageList(current, totalPage);
    setState(pre => ({...pre, current, indexs }));
    props.change && props.change(current);
  }
  const arrowClick = (type) => {   //点击了上一页 / 下一页
    let { current, totalPage } = state;
    if ((type=='prev' && current==1) || (type=='next' && current==totalPage)) return;
    type=='prev' ? current-- : current++;
    let indexs = assemblePageList(current, totalPage);
    setState(pre => ({...pre, current, indexs }));
    props.change && props.change(current);
  }

  return (
    <div className={`com-pagination-wrap ${props.className}`}>
      {props.layout=='total' ? <p className="com-total">共 {props.total} 条</p> : ''}
      <div className={`com-btn-prev ${state.current==1?'com-btn-disabled':''}`} onClick={() => arrowClick('prev')}></div>
      <ul className="com-pager" onClick={e => pageChange(e)}>
        {state.indexs.map((item, index) => 
          <li className={`com-number ${state.current==item?'com-num-active':''} ${isEps(item)?'com-point':''}`} data-item={item} key={index}>{isEps(item) ? '' : item}</li>
        )}
      </ul>
      <div className={`com-btn-next ${state.current==state.totalPage?'com-btn-disabled':''}`} onClick={() => arrowClick('next')}></div>
    </div>
  )
}

ComPagination.propTypes = {
  currentPage: PropTypes.number || PropTypes.string,
  pageSize: PropTypes.number || PropTypes.string,
  total: PropTypes.number || PropTypes.string,
  pagerCount: PropTypes.number,
  layout: PropTypes.string
}

export default withRouter(ComPagination);